import Edit16 from '@carbon/icons-react/es/edit/16';
import { Tooltip } from 'antd';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { EditButton } from 'components/organisms/timesheets/common/style';

interface Props {
  onClick: () => void;
}

export const EditRow: FC<Props> = ({ onClick }) => {
  return (
    <Tooltip
      title={<FormattedMessage id="timesheets.buttons.edit_adhoc_activity" />}
      placement="left"
    >
      <EditButton
        icon={<Edit16 />}
        data-cy="buttons.delete-row"
        onClick={onClick}
      />
    </Tooltip>
  );
};
